"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePageTitle = void 0;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var TITLE_MAP = {
    '': 'Главная',
    cars: 'Поиск автомобиля',
    credit: 'Заявка на автокредит',
    installment: 'Заявка на авто в рассрочку',
    buyout: 'Заявка на выкуп',
    exchange: 'Обмен автомобиля',
    banks: 'Банки',
    contacts: 'Контакты',
    about: 'О нас',
    favorites: 'Избранное',
    privacy: 'Политика конфиденциальности',
    admin: 'Панель управления',
};
var usePageTitle = function () {
    var location = (0, react_router_dom_1.useLocation)();
    react_1.default.useEffect(function () {
        var basePath = location.pathname.split('/').slice(0, 4);
        if (basePath[1] === 'car') {
            var carName = basePath[2];
            document.title = carName;
            return;
        }
        var pageTitle = TITLE_MAP[basePath[1]] || 'YouAuto';
        document.title = pageTitle;
    }, [location.pathname]);
};
exports.usePageTitle = usePageTitle;
